export class SearchResultModel<T> {
    private _hasItems: boolean;
    public get hasItems(): boolean {
        return this._hasItems;
    }

    private _items: T;
    public get items(): T{
        return this._items;
    }

    private _total: number;
    public get total(): number {
        return this._total;
    }

    private _page: number;
    public get page(): number {
        return this._page;
    }

    private _pages: number;
    public get pages(): number {
        return this._pages;
    }

    constructor(hasItems: boolean, items: T, total: number, page: number, pages: number){
        this._items = items;
        this._hasItems = hasItems;
        this._total=total;
        this._page = page;
        this._pages = pages;
    }
}